var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import IconWrapper from "./IconWrapper";
export default React.forwardRef((_a, ref) => {
    var { color = "primary" } = _a, otherProps = __rest(_a, ["color"]);
    return (React.createElement(IconWrapper, Object.assign({ ref: ref, width: 24, height: 24, color: color }, otherProps),
        React.createElement("path", { d: "M17.6485 15.2485C17.1799 15.7172 16.4201 15.7172 15.9515 15.2485L12 11.2971L8.04853 15.2485C7.5799 15.7172 6.8201 15.7172 6.35147 15.2485C5.88284 14.7799 5.88284 14.0201 6.35147 13.5515L11.1515 8.75148C11.6201 8.28285 12.3799 8.28285 12.8485 8.75148L17.6485 13.5515C18.1172 14.0201 18.1172 14.7799 17.6485 15.2485Z" })));
});
//# sourceMappingURL=ArrowUp.js.map